// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs_breadcrumbs__QaAH_","breadcrumbs__list":"Breadcrumbs_breadcrumbs__list__oVcT4","breadcrumbs__separator":"Breadcrumbs_breadcrumbs__separator__OSAOI"};